import { render, staticRenderFns } from "./ChatfuelMsgModal.vue?vue&type=template&id=169fc04a&scoped=true&"
import script from "./ChatfuelMsgModal.vue?vue&type=script&lang=js&"
export * from "./ChatfuelMsgModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatfuelMsgModal.vue?vue&type=style&index=0&id=169fc04a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169fc04a",
  null
  
)

export default component.exports